







































































































































import { EpigraphicUnitSide } from '@oare/types';
import { defineComponent, PropType } from '@vue/composition-api';

export default defineComponent({
  props: {
    side: {
      type: String as PropType<EpigraphicUnitSide>,
      required: true,
    },
  },
  setup(props) {
    const getObverseColor = () => {
      if (props.side === 'obv.') {
        return 'primary';
      } else if (props.side === 'mirror text') {
        return 'grey darken-1';
      }
    };
    return {
      getObverseColor,
    };
  },
});
